import { obj, required, array } from 'AppReact/schema';

export const dropdownIcon = {
  id: required('string'),
  labels: array('string'),
  icon: obj({}),
}
